import { AppName, CompanyName, getAppName } from 'modules/utils/ConfigUtils';

export const eVisitOverviewScreen = {
  screenTitle: 'E-Visit Overview',
  howItWorksItems: [
    {
      key: 'hiw01',
      importantText: 'Click on Start an E-Visit',
      regularText: 'to share your symptoms with a provider.'
    },
    { key: 'hiw02', importantText: 'Provider reviews and creates a plan', regularText: '' },
    {
      key: 'hiw03',
      importantText: 'Treatment plan is sent to you',
      regularText: '(Response in 1 to 2 hours*)'
    },
    {
      key: 'hiw04',
      importantText: '',
      regularText:
        'Treatment plan typically includes a diagnosis and next steps. Prescriptions are sent to the pharmacy of your choice (if applicable) are sent to the pharmacy of your choice. Your insurance will be billed for this visit. Please check with your insurance company for the details.**'
    },
    {
      key: 'hiw05',
      importantText: '',
      regularText:
        'E-Visits are currently being tested with a limited number of our patients. We appreciate your willingness to help with the development of this new method of delivering care. We will bill your insurance for this visit. If the provider determines they can’t treat you via an E-Visit and refer you elsewhere, there will be no charge for this E-Visit.  Please check with your insurance company for details.'
    },
    {
      key: 'hiw06',
      importantText: '',
      regularText:
        'At this time only COVID-19 testing can be ordered via E-Visits. Other tests, such as a rapid strep test, cannot be ordered through E-Visits.'
    },
    {
      key: 'hiw07',
      importantText: '',
      regularText: [
        {
          type: 'text',
          value:
            'Intermountain practices antibiotic stewardship which may limit antibiotics for certain conditions.  This protects patients from harm caused by unnecessary antibiotics and combats antibiotic resistance. Please click'
        },
        {
          type: 'link',
          value: ' here ',
          link: 'https://intermountainhealthcare.org/ckr-ext/Dcmnt?ncid=529408301'
        },
        { type: 'text', value: 'for more information' }
      ]
    }
  ],
  sectionTitle: {
    howItWorks: 'How it works',
    pricing: 'Pricing',
    conditions: 'Conditions treated with E-Visits'
  },
  button: {
    startEVisit: 'Start an E-Visit'
  },
  card: {
    title: 'Your out of pocket cost today',
    disclosure: 'Pricing based on your insurance coverage and may vary.'
  },
  treatedConditions: [
    'Common Cold',
    'Sinus Infection',
    'Seasonal Alllergies',
    'Sore Throat',
    'Flu',
    'COVID-19 Coronavirus',
    'Asthma',
    'Headache',
    'Pink Eye',
    'Sty',
    'Acid Reflux and Heartburn',
    'Stomach Virus/Stomach Flu',
    'urinary Tract Infection/UTI',
    'Bladder Infection',
    'Vaginal Yeast Infection',
    'New Low Back Pain'
  ],
  disclosureItems: [
    {
      key: 'dis01',
      content: 'Estimations based on normal daytime hours and may vary at night.',
      withAsterisk: true
    },
    {
      key: 'dis02',
      content:
        '(If you can not be treated with an E-Visit, you will be directed to another care option and will not be charged).',
      withAsterisk: false
    }
  ]
};

export const eVisitFrontDoorOverviewScreen = {
  screenTitle: 'E-Visit',
  howItWorksCards: [
    {
      key: 'hiwc01',
      title: 'Begin by answering a few questions then carry on with your day.'
    },
    {
      key: 'hiwc02',
      title: 'Next, a provider reviews and creates a treatment plan for you.'
    },
    {
      key: 'hiwc03',
      title: 'Then a provider will message your treatment plan & prescription if appropriate.'
    }
  ],

  sectionTitle: {
    title: 'E-Visit',
    subtitle: 'Same-day care without ever stepping into a clinic.',
    description: 'Affordable treatment anytime and anywhere.',
    buttonText: 'Get Treatment'
  },
  sectionSubtitle: {
    title: 'How it works',
    subtitle: 'Learn more about E-Visit same-day treatments'
  },
  disclosures: {
    info:
      'An E-Visit does not treat patients for emergency illnesses. If you feel you are experiencing an emergency medical problem, please call 911 or go to the nearest emergency room.',
    cost:
      'The cost of an E-Visit will not exceed $35. And, if you can’t be treated, you won’t be charged. Other insurance carriers will be added soon.',
    age: 'Only available for adults 18 years and older'
  },
  buttons: {
    startEVisit: 'Get started here'
  }
};

export const eVisitStateLocationConstants = {
  screenTitle: 'E-Visit',
  title: "Where it's available",
  headerText: 'E-Visits are only available in Utah, Idaho and Nevada at this time.',
  notInUtah: 'Not in this area?',
  consentCheckbox: `I have read and agree to ${getAppName(AppName.secondary, 'the')}`,
  consentCheckboxLink: 'Consent and Conditions of Service',
  noticeCheckbox: 'I acknowledge I have been offered the',
  noticeCheckboxLink: `${CompanyName} Notice of Privacy Practices`,
  termsOfUseCheckbox: 'I have read and agree to the E-Visit',
  termsOfUseCheckboxLink: 'Terms of Use'
};

export const eVisitFrontDoorTermsAndAgreementsScreen = {
  screenTitle: 'E-Visit',
  title: "Where it's available",
  headerText: 'An E-Visit is only available in Utah, Idaho, and Nevada at this time.',
  notInUtah: 'Not in this area?',
  consentCheckbox: 'I have read and agreed to the',
  consentCheckboxLink: `${getAppName(AppName.secondary)} Terms of Use`,
  noticeCheckbox: 'I acknowledge I have been offered the',
  noticeCheckboxLink: `${CompanyName} Notice of Privacy Practices`,
  termsOfUseCheckbox: 'I have read and agreed to the',
  termsOfUseCheckboxLink: 'E-Visit Terms of Use'
};

export const eVisitFrontDoorInsuranceScreen = {
  screenTitle: 'E-Visit',
  sectionTitle: {
    title: 'Insurance',
    description:
      'Please ensure that your insurance plan is correct by selecting “Confirm”. If not, please upload your new insurance plan card(s) or opt for self-pay.',
    cardsTitle: 'Insurance on file'
  },
  disclosures: {
    check: 'Please check with your insurance to verify your coverage of E-Visits.',
    cost:
      'The cost of an E-Visit will not exceed $35. You will not be charged if we can’t treat your symptoms with an E-Visit. Not all insurance covers E-Visits.',
    explain:
      'You may need to explain it as an asynchronous visit with a provider you haven’t previously seen in person or by video appointment. Government plans currently do not cover E-Visits.',
    selfPay: 'Selecting Self-pay means you are opting out of billing insurance for this visit.'
  },
  buttons: {
    addNewInsurance: 'Add new insurance',
    selfPay: 'Self-Pay',
    confirm: 'Confirm'
  }
};

export const eVisitFrontDoorNewInsuranceScreen = {
  screenTitle: 'E-Visit',
  sectionTitle: {
    title: 'Insurance',
    description:
      'Please upload your insurance card(s) by using your camera or upload from your library.'
  },
  sectionCards: {
    cardTitle: 'Add photo',
    cardDescription: 'Take a photo here or browse your photo library',
    processingTitle: 'Processing',
    processingDescription: 'Please wait as we upload your image',
    successTitle: 'Successful',
    successDescription: 'Press to preview or retake image',
    errorTitle: 'Error',
    errorDescription: 'There was an error uploading your image. '
  },
  sectionSubtitle: {
    title: 'Secondary Insurance',
    description: 'If applicable or in addition to your primary insurance.'
  },
  buttons: {
    addNewInsurance: 'Add new insurance',
    removeSecondaryInsurance: 'Remove adding secondary',
    confirm: 'Confirm'
  },
  errors: {
    default: 'There was an error with your file upload. Please try again later.',
    fileSize:
      'File size limit is 10MB. Please review your file and ensure your file is an accepted file type .PNG or .JPG.',
    attachmentLimitServer: 'Adding/Deleting attachment limit reached for a message',
    attachmentLimit: 'Adding/Deleting attachment limit reached for insurance upload'
  }
};

export const eVisitNotInUtahDialogConstants = {
  dialogTitleText: 'E-Visits are currently only available in Utah, Nevada and Idaho.',
  dialogContentText: 'Please check back to see if your location becomes available.',
  dialogButtonText: 'Ok'
};

export const EVISIT_CONFIRM_DIALOG_TEXT = {
  title: 'Are you sure you want to cancel this E-Visit?',
  subtitle: 'Your information will be lost.',
  primaryButton: 'Yes, cancel my E-Visit',
  secondaryButton: 'No, take me back'
};

export const EVISIT_STATES = [
  { label: 'Idaho', value: 'ID' },
  { label: 'Nevada', value: 'NV' },
  { label: 'Utah', value: 'UT' }
];

export const COVID19_CHECKER_CARD = {
  url: 'https://intermountainhealthcare.org/health-wellness-promotion/pandemics/covid/get-testing/'
};

export const COVID_GET_TESTING_INFO = {
  url: 'https://intermountainhealthcare.org/health-wellness-promotion/pandemics/covid/get-testing/'
};

export const COVID_VACCINE_INFO = {
  url: 'https://intermountainhealthcare.org/Health-Wellness-Promotion/Vaccines/COVID'
};
